import { render, staticRenderFns } from "./TelaLoading.vue?vue&type=template&id=8750e4b2&"
import script from "./TelaLoading.vue?vue&type=script&lang=js&"
export * from "./TelaLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports